// composables/useInput.ts
export interface Variants {
  base: {
    base: string;
    flat: string;
  };
  danger: string;
  success: string;
}

export interface Sizes {
  sm: string;
  md: string;
  lg: string;
}

export function useInput(
  props: {
    variant?: keyof Variants;
    size?: keyof Sizes;
    flat?: boolean;
    disabled?: boolean;
    sizes?: Sizes;
  },
  emit: (event: string, ...args: any[]) => void
) {
  const variants = ref<Variants>({
    base: {
      base: "bg-primary autofill:bg-secondary text-secondary placeholder-primary",
      flat: "bg-secondary autofill:bg-secondary text-secondary placeholder-primary",
    },
    danger: "border-red-300 bg-red-50 placeholder-red-200 text-red-900",
    success: "border-green-300 bg-green-50 placeholder-gray-400 text-green-900",
  });

  const sizes = ref<Sizes>(props.sizes || {
    sm: "h-8 text-xs px-3",
    md: "h-10 text-sm px-4",
    lg: "h-12 text-sm px-5",
  });

  const classes = computed(() => {
    const variant = props.variant;
    const variantClasses = variants.value;
    const classList: string[] = [];

    if (props.flat) {
      classList.push(
        variant
          ? (variantClasses[variant] as any)?.flat ||
              (variantClasses[variant] as any)
          : variantClasses.base.base
      );
    } else {
      classList.push(
        variant
          ? (variantClasses[variant] as any)?.base ||
              (variantClasses[variant] as any)
          : variantClasses.base.base
      );
    }

    const size = props.size;
    const sizeClasses = sizes.value;

    classList.push(size ? sizeClasses[size] : sizeClasses.md);

    return classList.join(" ");
  });

  const handlers = {
    blur: (e: Event) => emit("blur", e),
    focus: (e: Event) => emit("focus", e),
    keyup: (e: KeyboardEvent) => emit("keyup", e),
    keydown: (e: KeyboardEvent) => emit("keydown", e),
  };

  return {
    classes,
    handlers,
  };
}
